export enum ScanLabelArchetype {
  NONE = "",
  DECEASED = "Deceased",
  NON_READER = "Non-Reader",
  NO_TAG = "No Tag",
}
